



































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import {GithubUser} from '@/model/resource/GithubUser'
import {GithubUserCollection} from '@/model/collection/GithubUserCollection'
import {ListGithubUserSchema} from '@/schema/resource/GithubUser/ListGithubUserSchema'

@Component({
  components: {},
})
export default class ListGithubUserView extends Mixins(MixinRouteMatch) {
  schema = new ListGithubUserSchema()
  collection = new GithubUserCollection()

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }

    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  async removeItem(item: GithubUser) {
    await this.$dialog.remove(item)
    await item.removeGithubUser()
    await this.collection.queryAsPage()
  }

  goToPersistView(item: GithubUser) {
    this.$nav.pushByName('editGithubUser', item.$id)
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }
}
